import React from 'react'
import { slugToURL } from 'components/utils/schemaUtils'

const Breadcrumbs = (props) => {
  const { links } = props

  const breadcrumbs = links
    ? links.map((link, i) => {
      const url = slugToURL(link)

      return <a href={url} key={url}>
        <button className='ui button secondary basic'>
          {link.name}
        </button>
        {i < (links.length - 1) ? <span className='separator'>›</span> : ''}
      </a>
    })
    : null

  return <>{breadcrumbs}</>
}

export default Breadcrumbs